"use strict";
/**
 * Enums de domínio compartilhados entre API e mobile.
 *
 * Estes valores são espelhados nos enums do Prisma (`apps/api/prisma/schema.prisma`).
 * Ao alterar um valor aqui, altere também no schema e gere uma migration.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEEKDAY_SHORT_PT = exports.WEEKDAY_LABELS_PT = exports.Weekday = exports.AuditAction = exports.DataRequestStatus = exports.DataRequestType = exports.ConsentType = exports.NotificationChannel = exports.WHATSAPP_EVENTS = exports.WhatsappDestination = exports.WhatsappEvent = exports.NotificationType = exports.ExpenseCategory = exports.TransactionType = exports.BillingState = exports.PlatformInvoiceStatus = exports.PaymentMethod = exports.PaymentStatus = exports.FeeStatus = exports.FeeKind = exports.MatchResult = exports.CheckInStatus = exports.AttendanceStatus = exports.GameStatus = exports.POSITION_SECTOR = exports.POSITION_ORDER = exports.POSITION_SHORT_PT = exports.POSITION_LABELS_PT = exports.PlayerPosition = exports.MembershipStatus = exports.GROUP_ROLE_RANK = exports.GroupRole = void 0;
/** Papel de um usuário dentro de um grupo (RBAC por grupo, nunca global). */
exports.GroupRole = {
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    MEMBER: 'MEMBER',
};
/** Hierarquia numérica para comparação de papéis (maior = mais poder). */
exports.GROUP_ROLE_RANK = {
    MEMBER: 1,
    ADMIN: 2,
    OWNER: 3,
};
/** Situação do vínculo entre usuário e grupo. */
exports.MembershipStatus = {
    /** Aguardando aprovação de um administrador (entrada por link público). */
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    /** Temporariamente suspenso — não recebe cobranças nem entra em partidas. */
    SUSPENDED: 'SUSPENDED',
    /** Saiu ou foi removido. Mantido para preservar histórico. */
    LEFT: 'LEFT',
};
/**
 * Posição em campo.
 *
 * "Pode jogar no gol" é um dado separado (`canPlayGoalkeeper`), não um valor
 * daqui: um meio-campista que quebra o galho no gol continua sendo
 * meio-campista, e o time precisa saber disso.
 */
exports.PlayerPosition = {
    GOALKEEPER: 'GOALKEEPER',
    DEFENDER: 'DEFENDER',
    FULLBACK: 'FULLBACK',
    MIDFIELDER: 'MIDFIELDER',
    FORWARD: 'FORWARD',
};
exports.POSITION_LABELS_PT = {
    GOALKEEPER: 'Goleiro',
    DEFENDER: 'Zagueiro',
    FULLBACK: 'Lateral',
    MIDFIELDER: 'Meio-campo',
    FORWARD: 'Atacante',
};
exports.POSITION_SHORT_PT = {
    GOALKEEPER: 'GOL',
    DEFENDER: 'ZAG',
    FULLBACK: 'LAT',
    MIDFIELDER: 'MEI',
    FORWARD: 'ATA',
};
/**
 * Ordem de exibição — do gol para o ataque, como se lê uma escalação.
 * Alfabética deixaria "Atacante, Goleiro, Lateral…", que não é como ninguém
 * pensa em time de futebol.
 */
exports.POSITION_ORDER = [
    'GOALKEEPER',
    'DEFENDER',
    'FULLBACK',
    'MIDFIELDER',
    'FORWARD',
];
/**
 * Setor do campo, para o algoritmo distribuir os times.
 *
 * Zagueiro e lateral defendem; o balanceador não precisa da distinção fina, só
 * evitar um time com cinco defensores e outro com cinco atacantes.
 */
exports.POSITION_SECTOR = {
    GOALKEEPER: 'GOAL',
    DEFENDER: 'DEFENSE',
    FULLBACK: 'DEFENSE',
    MIDFIELDER: 'MIDFIELD',
    FORWARD: 'ATTACK',
};
/** Ciclo de vida de uma partida. */
exports.GameStatus = {
    /** Criada automaticamente pelo job de recorrência, ainda não anunciada. */
    DRAFT: 'DRAFT',
    /** Aberta para confirmação de presença. */
    SCHEDULED: 'SCHEDULED',
    /** Times gerados/publicados. */
    TEAMS_DRAWN: 'TEAMS_DRAWN',
    IN_PROGRESS: 'IN_PROGRESS',
    /** Encerrada — libera janela de avaliações. */
    FINISHED: 'FINISHED',
    CANCELED: 'CANCELED',
};
/** Resposta do jogador ao convite da partida. */
exports.AttendanceStatus = {
    CONFIRMED: 'CONFIRMED',
    DECLINED: 'DECLINED',
    MAYBE: 'MAYBE',
    /** Fila de espera — entra automaticamente quando abre vaga. */
    WAITLIST: 'WAITLIST',
    /** Não respondeu até o fechamento da lista. */
    NO_RESPONSE: 'NO_RESPONSE',
};
/** Presença física conferida pelo administrador no dia do jogo. */
exports.CheckInStatus = {
    PENDING: 'PENDING',
    PRESENT: 'PRESENT',
    /** Confirmou e não apareceu — conta como falta no histórico. */
    ABSENT: 'ABSENT',
    LATE: 'LATE',
};
/** Resultado de uma partida para um time. */
exports.MatchResult = {
    WIN: 'WIN',
    DRAW: 'DRAW',
    LOSS: 'LOSS',
};
/** Situação de uma mensalidade. */
/** Mensalidade do mês ou cobrança avulsa (racha, churrasco). */
exports.FeeKind = {
    MONTHLY: 'MONTHLY',
    EXTRA: 'EXTRA',
};
exports.FeeStatus = {
    PENDING: 'PENDING',
    PAID: 'PAID',
    OVERDUE: 'OVERDUE',
    CANCELED: 'CANCELED',
    /** Dispensada pelo administrador (ex.: jogador lesionado). */
    WAIVED: 'WAIVED',
};
/** Situação de uma cobrança/pagamento junto ao provedor. */
exports.PaymentStatus = {
    /** Cobrança criada localmente, ainda não enviada ao provedor. */
    CREATED: 'CREATED',
    /** Aguardando pagamento (QR Code ativo). */
    PENDING: 'PENDING',
    /** Confirmado exclusivamente via webhook autenticado do provedor. */
    CONFIRMED: 'CONFIRMED',
    EXPIRED: 'EXPIRED',
    REFUNDED: 'REFUNDED',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED',
};
/** Método de pagamento registrado. */
exports.PaymentMethod = {
    PIX: 'PIX',
    CASH: 'CASH',
    TRANSFER: 'TRANSFER',
    CARD: 'CARD',
    OTHER: 'OTHER',
};
/** Fatura da assinatura que a plataforma cobra do dono do grupo. */
exports.PlatformInvoiceStatus = {
    PENDING: 'PENDING',
    /** Comprovante enviado, aguardando conferência — não bloqueia o grupo. */
    IN_REVIEW: 'IN_REVIEW',
    PAID: 'PAID',
    WAIVED: 'WAIVED',
    CANCELED: 'CANCELED',
};
/**
 * Situação da assinatura de um grupo, calculada a partir das faturas.
 * BLOCKED = vencida há mais que a carência: o grupo fica somente leitura.
 */
exports.BillingState = {
    /** Cobrança da plataforma desligada (preço 0). */
    DISABLED: 'DISABLED',
    EXEMPT: 'EXEMPT',
    OK: 'OK',
    /** Fatura em aberto, ainda no prazo. */
    DUE: 'DUE',
    /** Comprovante enviado, aguardando conferência. */
    IN_REVIEW: 'IN_REVIEW',
    /** Vencida, dentro da carência. */
    OVERDUE: 'OVERDUE',
    BLOCKED: 'BLOCKED',
};
/** Natureza de um lançamento no caixa do grupo. */
exports.TransactionType = {
    INCOME: 'INCOME',
    EXPENSE: 'EXPENSE',
    /** Ajuste manual de saldo (com justificativa obrigatória). */
    ADJUSTMENT: 'ADJUSTMENT',
};
/** Categorias de despesa do grupo. */
exports.ExpenseCategory = {
    FIELD_RENTAL: 'FIELD_RENTAL',
    WATER: 'WATER',
    BIBS: 'BIBS',
    BALL: 'BALL',
    REFEREE: 'REFEREE',
    BARBECUE: 'BARBECUE',
    EQUIPMENT: 'EQUIPMENT',
    OTHER: 'OTHER',
};
/** Tipos de notificação enviados ao usuário. */
exports.NotificationType = {
    GAME_REMINDER_DAY_BEFORE: 'GAME_REMINDER_DAY_BEFORE',
    GAME_REMINDER_HOURS_BEFORE: 'GAME_REMINDER_HOURS_BEFORE',
    GAME_CREATED: 'GAME_CREATED',
    GAME_CANCELED: 'GAME_CANCELED',
    GAME_UPDATED: 'GAME_UPDATED',
    SPOT_AVAILABLE: 'SPOT_AVAILABLE',
    WAITLIST_PROMOTED: 'WAITLIST_PROMOTED',
    TEAMS_PUBLISHED: 'TEAMS_PUBLISHED',
    RATING_WINDOW_OPEN: 'RATING_WINDOW_OPEN',
    RATING_UPDATED: 'RATING_UPDATED',
    FEE_DUE_SOON: 'FEE_DUE_SOON',
    FEE_OVERDUE: 'FEE_OVERDUE',
    PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',
    MEMBER_JOIN_REQUEST: 'MEMBER_JOIN_REQUEST',
    MEMBER_JOINED: 'MEMBER_JOINED',
    ROLE_CHANGED: 'ROLE_CHANGED',
    /** Fatura da assinatura da plataforma, para o dono do grupo. */
    BILLING_INVOICE: 'BILLING_INVOICE',
    GENERIC: 'GENERIC',
};
/** Mensagens que o bot de WhatsApp pode enviar por pelada. */
exports.WhatsappEvent = {
    FEES_GENERATED: 'FEES_GENERATED',
    FEE_DUE_SOON: 'FEE_DUE_SOON',
    FEE_OVERDUE: 'FEE_OVERDUE',
    PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',
    GAME_CREATED: 'GAME_CREATED',
    GAME_REMINDER: 'GAME_REMINDER',
    GAME_UPDATED: 'GAME_UPDATED',
    GAME_CANCELED: 'GAME_CANCELED',
    TEAMS_PUBLISHED: 'TEAMS_PUBLISHED',
};
/** Para onde vai cada mensagem: grupo da pelada, privado de cada jogador, ambos ou nada. */
exports.WhatsappDestination = {
    GROUP: 'GROUP',
    PRIVATE: 'PRIVATE',
    BOTH: 'BOTH',
    OFF: 'OFF',
};
/**
 * Catálogo dos eventos com o destino padrão.
 *
 * Cobrança sai no privado por padrão: mandar no grupo expõe quem está
 * devendo. Partida e times saem no grupo, que é onde a turma conversa.
 */
exports.WHATSAPP_EVENTS = [
    {
        key: 'FEES_GENERATED',
        label: 'Mensalidades e cobranças lançadas',
        description: 'Quando o admin lança a mensalidade do mês ou uma cobrança avulsa, com valor, vencimento e link para pagar.',
        defaultDestination: 'PRIVATE',
    },
    {
        key: 'FEE_DUE_SOON',
        label: 'Lembrete de vencimento',
        description: 'Alguns dias antes do vencimento, para quem ainda não pagou.',
        defaultDestination: 'PRIVATE',
    },
    {
        key: 'FEE_OVERDUE',
        label: 'Mensalidade em atraso',
        description: 'Quando a mensalidade vence sem pagamento. No grupo sai só a contagem, sem nomes.',
        defaultDestination: 'PRIVATE',
    },
    {
        key: 'PAYMENT_CONFIRMED',
        label: 'Pagamento confirmado',
        description: 'Confirmação para quem pagou. No grupo, avisa que fulano pagou.',
        defaultDestination: 'PRIVATE',
    },
    {
        key: 'GAME_CREATED',
        label: 'Nova partida marcada',
        description: 'Data, horário, local e link para confirmar presença.',
        defaultDestination: 'GROUP',
    },
    {
        key: 'GAME_REMINDER',
        label: 'Lembrete na véspera',
        description: 'Um dia antes, com quantos já confirmaram.',
        defaultDestination: 'GROUP',
    },
    {
        key: 'GAME_UPDATED',
        label: 'Partida alterada',
        description: 'Quando muda o horário ou o local da partida.',
        defaultDestination: 'GROUP',
    },
    {
        key: 'GAME_CANCELED',
        label: 'Partida cancelada',
        description: 'Aviso de cancelamento com o motivo.',
        defaultDestination: 'GROUP',
    },
    {
        key: 'TEAMS_PUBLISHED',
        label: 'Times sorteados',
        description: 'A escalação completa de cada time. No privado, cada um recebe o próprio time.',
        defaultDestination: 'GROUP',
    },
];
/** Canal de entrega da notificação. */
exports.NotificationChannel = {
    PUSH: 'PUSH',
    EMAIL: 'EMAIL',
    IN_APP: 'IN_APP',
};
/** Tipos de consentimento LGPD registrados por usuário. */
exports.ConsentType = {
    TERMS_OF_USE: 'TERMS_OF_USE',
    PRIVACY_POLICY: 'PRIVACY_POLICY',
    MARKETING_EMAILS: 'MARKETING_EMAILS',
    PUSH_NOTIFICATIONS: 'PUSH_NOTIFICATIONS',
    /** Exibir estatísticas do usuário no ranking do grupo. */
    STATS_SHARING: 'STATS_SHARING',
};
/** Situação de uma solicitação LGPD (art. 18). */
exports.DataRequestType = {
    EXPORT: 'EXPORT',
    DELETION: 'DELETION',
    ANONYMIZATION: 'ANONYMIZATION',
};
exports.DataRequestStatus = {
    REQUESTED: 'REQUESTED',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED',
    CANCELED: 'CANCELED',
};
/** Ações registradas na trilha de auditoria. */
exports.AuditAction = {
    AUTH_LOGIN: 'AUTH_LOGIN',
    AUTH_LOGIN_FAILED: 'AUTH_LOGIN_FAILED',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
    AUTH_LOGOUT_ALL: 'AUTH_LOGOUT_ALL',
    AUTH_PASSWORD_CHANGED: 'AUTH_PASSWORD_CHANGED',
    AUTH_PASSWORD_RESET: 'AUTH_PASSWORD_RESET',
    AUTH_EMAIL_VERIFIED: 'AUTH_EMAIL_VERIFIED',
    USER_UPDATED: 'USER_UPDATED',
    USER_DELETED: 'USER_DELETED',
    USER_ANONYMIZED: 'USER_ANONYMIZED',
    USER_DATA_EXPORTED: 'USER_DATA_EXPORTED',
    GROUP_CREATED: 'GROUP_CREATED',
    GROUP_UPDATED: 'GROUP_UPDATED',
    GROUP_DELETED: 'GROUP_DELETED',
    GROUP_SETTINGS_UPDATED: 'GROUP_SETTINGS_UPDATED',
    GROUP_OWNERSHIP_TRANSFERRED: 'GROUP_OWNERSHIP_TRANSFERRED',
    MEMBER_INVITED: 'MEMBER_INVITED',
    MEMBER_JOINED: 'MEMBER_JOINED',
    MEMBER_APPROVED: 'MEMBER_APPROVED',
    MEMBER_REJECTED: 'MEMBER_REJECTED',
    MEMBER_REMOVED: 'MEMBER_REMOVED',
    MEMBER_ROLE_CHANGED: 'MEMBER_ROLE_CHANGED',
    MEMBER_SKILL_OVERRIDDEN: 'MEMBER_SKILL_OVERRIDDEN',
    INVITE_CREATED: 'INVITE_CREATED',
    INVITE_REVOKED: 'INVITE_REVOKED',
    GAME_CREATED: 'GAME_CREATED',
    GAME_UPDATED: 'GAME_UPDATED',
    GAME_CANCELED: 'GAME_CANCELED',
    GAME_FINISHED: 'GAME_FINISHED',
    ATTENDANCE_CHANGED: 'ATTENDANCE_CHANGED',
    GUEST_ADDED: 'GUEST_ADDED',
    GUEST_REMOVED: 'GUEST_REMOVED',
    TEAMS_GENERATED: 'TEAMS_GENERATED',
    TEAMS_UPDATED: 'TEAMS_UPDATED',
    SCORE_REGISTERED: 'SCORE_REGISTERED',
    RATING_SUBMITTED: 'RATING_SUBMITTED',
    RATING_RECALCULATED: 'RATING_RECALCULATED',
    FEE_GENERATED: 'FEE_GENERATED',
    FEE_UPDATED: 'FEE_UPDATED',
    FEE_WAIVED: 'FEE_WAIVED',
    PAYMENT_CREATED: 'PAYMENT_CREATED',
    PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',
    PAYMENT_REFUNDED: 'PAYMENT_REFUNDED',
    /** Admin marcou como não pago um pagamento confirmado por pessoa. */
    PAYMENT_REVERTED: 'PAYMENT_REVERTED',
    EXPENSE_CREATED: 'EXPENSE_CREATED',
    EXPENSE_UPDATED: 'EXPENSE_UPDATED',
    EXPENSE_DELETED: 'EXPENSE_DELETED',
    TRANSACTION_CREATED: 'TRANSACTION_CREATED',
    /** Admin excluiu um lançamento do caixa (anulado + estorno). */
    TRANSACTION_VOIDED: 'TRANSACTION_VOIDED',
    CONSENT_GRANTED: 'CONSENT_GRANTED',
    CONSENT_REVOKED: 'CONSENT_REVOKED',
    // Assinatura da plataforma
    BILLING_SETTINGS_UPDATED: 'BILLING_SETTINGS_UPDATED',
    BILLING_GROUP_UPDATED: 'BILLING_GROUP_UPDATED',
    BILLING_INVOICES_GENERATED: 'BILLING_INVOICES_GENERATED',
    BILLING_RECEIPT_SUBMITTED: 'BILLING_RECEIPT_SUBMITTED',
    BILLING_INVOICE_CONFIRMED: 'BILLING_INVOICE_CONFIRMED',
    BILLING_INVOICE_REJECTED: 'BILLING_INVOICE_REJECTED',
    BILLING_INVOICE_WAIVED: 'BILLING_INVOICE_WAIVED',
};
/** Dias da semana — 0 = domingo, alinhado com `Date.getDay()`. */
exports.Weekday = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
};
exports.WEEKDAY_LABELS_PT = {
    0: 'Domingo',
    1: 'Segunda-feira',
    2: 'Terça-feira',
    3: 'Quarta-feira',
    4: 'Quinta-feira',
    5: 'Sexta-feira',
    6: 'Sábado',
};
exports.WEEKDAY_SHORT_PT = {
    0: 'Dom',
    1: 'Seg',
    2: 'Ter',
    3: 'Qua',
    4: 'Qui',
    5: 'Sex',
    6: 'Sáb',
};
//# sourceMappingURL=enums.js.map